import { LISCase, LISCaseList, LISLabOrder } from "pwapi";

type FlagInfo = {
  flagReasonCode?: string;
  flagNote?: string | null;
};
export const getOrderFlagInfo = (
  order?: LISLabOrder,
  pathCase?: LISCase | LISCaseList
): FlagInfo => {
  const emptyFlagInfo: FlagInfo = {
    flagReasonCode: undefined,
    flagNote: undefined,
  };

  if (!order || !pathCase) return emptyFlagInfo;
  if (!order?.flag) return emptyFlagInfo;
  if (!pathCase.slides.length) return emptyFlagInfo;

  const orderSlide = pathCase.slides.find((s) => s.id === order.slide_id);
  if (!orderSlide) return emptyFlagInfo;

  const orderFlag = orderSlide.flags?.find((f) => f.order_id === order.id);
  if (!orderFlag) return emptyFlagInfo;

  // Return this Order Slide's Flag Information
  return { flagReasonCode: orderFlag.reason, flagNote: orderFlag.note };
};
